import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const prodKey = import.meta.env.VITE_APP_INSIGHTS_KEY_PRODUCTION_INTERNAL;
const intKey = import.meta.env.VITE_APP_INSIGHTS_KEY_INTEGRATION_INTERNAL;

const instrumentationKey = prodKey || intKey;

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey,
    enableAutoRouteTracking: true,
  },
});

appInsights.loadAppInsights();

// Add Telemetry Initializer for global properties
appInsights.addTelemetryInitializer((envelope) => {
  envelope.tags['ai.cloud.role'] = 'FrontEndApp'; // Set custom role name
  envelope.data = envelope.data || {};
  envelope.data.environment = import.meta.env.DEV ? 'local' : 'production'; // Set environment property
  envelope.data.appVersion = import.meta.env.VITE_APP_VERSION || '1.0.0'; // Set application version
});

// Set user context for logs
export const setUserContext = (userId, accountId = null) => {
  appInsights.setAuthenticatedUserContext(userId, accountId);
};

// Track custom events
export const trackEvent = (name, properties = {}) => {
  appInsights.trackEvent({ name, properties });
};

// Track exceptions with additional properties
export const trackException = (error, severityLevel = 3, properties = {}) => {
  appInsights.trackException({
    exception: error,
    severityLevel,
    properties,
  });
};

// Track warnings (traces with severity level 2)
export const trackWarning = (message, properties = {}) => {
  appInsights.trackTrace({
    message,
    severityLevel: 2,
    properties,
  });
};

// Default export
export default appInsights;
